import React from 'react';

export default function Loading() {
  return (
    <div className="loadingProcess">
      <div class="spin"></div>
    </div>
  );
}
